import { ProductProps } from '../../type'
import { ProductCategory, ProductTag } from '../../enum'
import imageBanner from './img/banner.png'
import imageTable from './img/table.jpg'

export const dcEvCharger: ProductProps = {
  tag: ProductTag.PV,
  category: ProductCategory.DistributedPVStorageSystems,
  pathName: 'dc-ev-charger',
  banner: imageBanner,
  title: '60/120/160kW Integrated DC EV Charger Series\nfor Commercial Scenarios',
  description: 'Scenarios:Highway charging,Public Charging,EV Rental Company,Industrial Park,Logistics Park',
  features: [
    {
      type: 'card-list',
      content: [
        {
          icon: 'safety',
          title: 'Intelligent & Efficient',
          description: ['Intelligent power module management', 'Customized charging modes', 'Dynamic load balance'],
        },
        {
          icon: 'safety',
          title: 'Flexible & Convenient',
          description: [
            'Colorful touch screen with HMI interface',
            'Remote control, diagnostics and upgrades',
            'Various charging ports',
            'Multiple backend management platforms',
          ],
        },
        {
          icon: 'safety',
          title: 'Secure & Reliable',
          description: [
            'Meets North American market standards',
            'Charger and BMS safety interlocking',
            'Multiple interface safety protection',
            'Rich internal protection of charger',
            'MTBF>8760h',
          ],
        },
      ],
    },
  ],
  specImages: [imageTable],
}
